module.exports = "# Ian and Sara Intro\n\nYouTube: 8drRLkLjcTw\n\n## Notes\nIntro to the Esmeralda and Goober Closing Story (0:42).\n\n# Esmeralda and Goober Closing Story\n\nYouTube: IjijiyJNzaM\n\n## Notes\nEsmeralda gives the Apprentices their second mission (1:04).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/60_esClosingStory/level2_closing.md
// module id = 1861
// module chunks = 2